import { ContainerModule } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';
import { WalletServiceInterface } from 'src/features/pariWallet/data/service/WalletService.types';
import GetWalletTransactionsUseCase from 'src/features/pariWallet/domain/useCases/GetWalletTransactionsUseCase';
import GetWalletUseCase from 'src/features/pariWallet/domain/useCases/GetWalletUseCase';
import GetAvailableCreditsUseCase from 'src/features/pariWallet/domain/useCases/GetAvailableCreditsUseCase';
import GetAvailableTransactionsUseCase from 'src/features/pariWallet/domain/useCases/GetAvailableTransactionsUseCase';
import GetSpentTransactionsUseCase from 'src/features/pariWallet/domain/useCases/GetSpentTransactionsUseCase';
import GetAvailableSpentTransactionsUseCase from 'src/features/pariWallet/domain/useCases/GetAvailableSpentTransactionsUseCase';
import GetWalletMaxUsageConfigUseCase from 'src/features/pariWallet/domain/useCases/GetWalletMaxUsageConfigUseCase';
import {
  GetWalletTransactionsUseCaseInterface,
  GetWalletUseCaseInterface,
  GetAvailableCreditsUseCaseInterface,
  GetAvailableTransactionsUseCaseInterface,
  GetSpentTransactionsUseCaseInterface,
  GetAvailableSpentTransactionsUseCaseInterface,
  GetWalletMaxUsageConfigUseCaseInterface,
} from 'src/features/pariWallet/domain/WalletUseCases.types';

export const walletBindings = new ContainerModule((bind) => {
  // Services
  bind<WalletServiceInterface>(WalletService).to(WalletService);

  // Use cases
  bind<GetWalletUseCaseInterface>(GetWalletUseCase).to(GetWalletUseCase);
  bind<GetWalletTransactionsUseCaseInterface>(GetWalletTransactionsUseCase).to(
    GetWalletTransactionsUseCase
  );
  bind<GetAvailableCreditsUseCaseInterface>(GetAvailableCreditsUseCase).to(
    GetAvailableCreditsUseCase
  );
  bind<GetAvailableTransactionsUseCaseInterface>(
    GetAvailableTransactionsUseCase
  ).to(GetAvailableTransactionsUseCase);
  bind<GetSpentTransactionsUseCaseInterface>(GetSpentTransactionsUseCase).to(
    GetSpentTransactionsUseCase
  );
  bind<GetAvailableSpentTransactionsUseCaseInterface>(
    GetAvailableSpentTransactionsUseCase
  ).to(GetAvailableSpentTransactionsUseCase);
  bind<GetWalletMaxUsageConfigUseCaseInterface>(
    GetWalletMaxUsageConfigUseCase
  ).to(GetWalletMaxUsageConfigUseCase);
});
